import requestv2 from "~/utils/http-v2";

const salaryPaymentApi = {
	payable : async (params) => {
		const url = 'v2/salary-payment/payable';
		return await requestv2.get(url, {params});
	},
	gets : async (params) => {
		const url = 'v2/salary-payment';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/salary-payment';
		return await requestv2.post(url, params);
	},
	delete : async (id) => {
		const url = `v2/salary-payment/${id}`;
		return await requestv2.delete(url);
	},
};

export default salaryPaymentApi;
